define.alias("shared/components/shared/social/tiktok-details", "preview-grid/components/shared/social/tiktok-details");